import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../components/formComponents/inputs/TextInput';
import VerbButton, { VERB_BUTTON_TYPE } from '../../components/VerbButton';
import UserAvatar from '../../components/UserAvatar';

export default class ReviewWorkspaceCommentReplies extends PureComponent {
    static propTypes = {
        renderCommentAuthor: PropTypes.func,
        renderCommentBody: PropTypes.func,
        toggleShowReplies: PropTypes.func,
        handleAssetReviewItemSubmit: PropTypes.func,
        replyItems: PropTypes.array,
        assetReviewItem: PropTypes.object,
        showReplies: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            replyBody: ''
        };
    }

    _renderReplyComment = (reviewItem) => {
        const { _id, createdOn, body, userProfileId, userFirstName, userLastName } = reviewItem;
        const user = { _id: userProfileId, firstName: userFirstName, lastName: userLastName };
        const { renderCommentAuthor, renderCommentBody } = this.props;

        return (
            <div className={'child-comment'} key={_id}>
                <UserAvatar size={'thumbnail'} user={user} circle={true} includeLink={false} className={'col-2'} />
                <div className={'reply-comment-body col-10'}>
                    {renderCommentAuthor(reviewItem)}
                    {renderCommentBody(body, createdOn)}
                </div>
            </div>
        );
    };

    _handleReplySubmit = () => {
        const { assetReviewItem, handleAssetReviewItemSubmit } = this.props;
        const { replyBody } = this.state;
        return handleAssetReviewItemSubmit({ body: replyBody, parentCommentId: assetReviewItem._id }).then(() =>
            this.setState({ replyBody: '' })
        );
    };

    render() {
        const { replyItems, toggleShowReplies, showReplies } = this.props;
        const { replyBody } = this.state;

        return (
            <div className={'comment-replies-container'}>
                {replyItems.length ? (
                    <div className={'reply-count col-11 col-offset-1'} onClick={toggleShowReplies}>
                        {replyItems.length} {replyItems.length === 1 ? 'Reply' : 'Replies'}
                        {showReplies ? <hr /> : null}
                    </div>
                ) : null}
                {replyItems.length && showReplies ? (
                    <div className={'child-comments col-11 col-offset-1'}>
                        {replyItems.map((item) => this._renderReplyComment(item))}
                    </div>
                ) : null}
                {showReplies && (
                    <div className={'reply-input-container col-11 col-offset-1'}>
                        <TextInput
                            componentClass={'textarea'}
                            rows={1}
                            value={replyBody}
                            onChange={(e) => this.setState({ replyBody: e.target.value })}
                            placeholder={'Type your reply...'}
                            className={'reply-input'}
                        />
                        <VerbButton
                            className={'reply-submit-btn col-offset-8 col-2'}
                            buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                            disabled={!(replyBody && replyBody.length)}
                            defaultMessage={'SEND'}
                            textId={'BUTTON_SEND'}
                            onClick={this._handleReplySubmit}
                        />
                    </div>
                )}
            </div>
        );
    }
}
